import { useState } from 'react';

const CTASection = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    npi: '',
    practiceName: '',
    state: '',
    message: '',
    agree: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  const benefits = [
    "100% HIPAA-Compliant Medical Billing",
    "Less than 1% Rejection",
    "99% Acceptance",
    "No Hidden Fees",
    "Enhance reimbursement outcomes",
    "24/7 Access",
    "As low as 2.99% of monthly collections"
  ];

  return (
    <section className="bg-white py-10">
      <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          
          {/* Left Side - Benefits */}
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 leading-tight">
              <span className="text-blue-500">Unlock the</span>{' '}
              <span className="text-gray-900">Full Potential of Your Practice</span>{' '}
              <span className="text-blue-500">Revenue</span>
            </h2>
            
            <p className="text-gray-600 text-base lg:text-lg mb-8 leading-relaxed">
              Increase the revenue of your practice with smooth and professional billing. Our team of medical billers and coders ensures payments 
              arrive on time, every time.
            </p>

            <div className="space-y-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10" strokeWidth="2" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                    </svg>
                  </div>
                  <span className="ml-3 text-gray-700 text-base">{benefit}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Side - Form */}
          <div className="bg-white rounded-3xl border-2 border-blue-200 p-8 lg:p-10">
            <h3 className="text-2xl font-bold text-blue-500 text-center mb-8">
              Benefits to Hire <span className='text-gray-900'>iSolve RCM</span>
            </h3>

            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Row 1 */}
              <div className="grid md:grid-cols-2 gap-4">
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="Enter Your Full Name"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                />
              </div>

              {/* Row 2 */}
              <div className="grid md:grid-cols-2 gap-4">
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone Number"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                />
                <input
                  type="text"
                  name="npi"
                  value={formData.npi}
                  onChange={handleChange}
                  placeholder="NPI (Optional)"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                />
              </div>

              {/* Row 3 */}
              <div className="grid md:grid-cols-2 gap-4">
                <input
                  type="text"
                  name="practiceName"
                  value={formData.practiceName}
                  onChange={handleChange}
                  placeholder="Practice Name"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                />
                <input
                  type="text"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  placeholder="State"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                />
              </div>

              {/* Message */}
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Message"
                rows="4"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent resize-none"
              ></textarea>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full bg-blue-800 hover:bg-blue-700 text-white font-bold py-4 rounded-lg transition-colors shadow-lg"
              >
                Submit
              </button>
            </form>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CTASection;
